/* eslint "react/prop-types": "warn" */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';

import DatabaseSidebar from './DatabaseSidebar.jsx';
import SidebarLayout from 'metabase/components/SidebarLayout.jsx';
import DatabaseDetail from "metabase/reference/databases/DatabaseDetail.jsx"

import * as metadataActions from 'metabase/redux/metadata';
import * as actions from 'metabase/reference/reference';

import {
    getDatabase,
    getDatabaseId,
    getIsEditing
} from '../selectors';


const mapStateToProps = (state, props) => ({
    database: getDatabase(state, props),
    databaseId: getDatabaseId(state, props),
    isEditing: getIsEditing(state, props)
});

const mapDispatchToProps = {
    ...metadataActions,
    ...actions
};

@connect(mapStateToProps, mapDispatchToProps)
export default class DatabaseDetailContainer extends Component {
    static propTypes = {
        params: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        database: PropTypes.object.isRequired,
        databaseId: PropTypes.number.isRequired,
        isEditing: PropTypes.bool
    };

    async fetchContainerData(){
        await actions.wrappedFetchDatabaseMetadata(this.props, this.props.databaseId);
    }

    componentWillMount() {
        this.fetchContainerData()
    }

    componentWillReceiveProps(newProps) {
        if (this.props.location.pathname === newProps.location.pathname) {
            return;
        }

        actions.clearState(newProps)
    }

    render() {
        const {
            database,
            isEditing
        } = this.props;


        return (
            <SidebarLayout
                className="flex-full relative"
                style={ isEditing ? { paddingTop: '43px' } : {}}
                sidebar={<DatabaseSidebar database={database} />}
            >
                <DatabaseDetail {...this.props} />
            </SidebarLayout>
        );
    }
}



// WEBPACK FOOTER //
// ./reference/databases/DatabaseDetailContainer.jsx